import * as React from "react";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";

export default function BasicDatePicker({ value, onChange, label }) {
  // Use the browser's forgiving `new Date()` to parse the ambiguous string from the API.
  // Then, pass the resulting valid Date object to dayjs for robust handling.
  // This prevents dayjs from failing on timezone-less ISO strings.
  const potentialDate = dayjs(new Date(value));

  const isDateValid = potentialDate.isValid();

  // Only pass a valid dayjs object to the DatePicker, otherwise pass null.
  const dateValue = isDateValid ? potentialDate : null;
  console.log("value", value);
  console.log("dateValue", dateValue);

  const handleDateChange = (newDate) => {
    // On change, format back to a standard, unambiguous ISO string (UTC).
    onChange(newDate ? newDate.toISOString() : null);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoItem label={label}>
        <DatePicker
          value={dateValue}
          onChange={handleDateChange}
          views={["year", "month", "day"]}
        />
      </DemoItem>
    </LocalizationProvider>
  );
}
